import { clsx } from 'external/clsx'
import { isUUID } from 'external/lodash'
import { Button, FC, useMemo } from 'external/react'
import Icon from 'external/fortawesome'
import Avatar from 'components/Avatar'
import { Package, PackageState } from 'types/context/package'
import { ContextState, UpdateFunction } from 'types/context/context'

type SelectTutorProps = {
    className?: string
    packageItem: Package | null
    update?: UpdateFunction<ContextState<PackageState>>
    changed?: () => void
}

const SelectTutor:FC<SelectTutorProps> = props => {

	const {changed, update, packageItem, className = 'card flex-grow-1 mb-3 d-flex flex-column justify-content-center'} = props

    const selectedTutor = packageItem?.tutor

    const hasTutor = useMemo(() => isUUID(selectedTutor?.id), [selectedTutor])

    function handleSelectTutorClick() {
        const selectTutorModal = {
            open: true, selectedUser: selectedTutor, purchase: packageItem
        }
        update && update({modals: {selectTutor: {$shallow: selectTutorModal}}})
        changed && changed()
    }
    
    function handleRemoveTutorClick() {
        update && update({packageItem: {data: {tutor: {$set: null}}}})
        changed &&changed()
    }

	return (
        <div className={className}>
            <Button variant='outline-primary' size='lg' className={clsx('w-100', {'d-none': hasTutor || !update})} style={{ height: '86px' }} onClick={handleSelectTutorClick} >
                <Icon name='faUserTie' /> Selecciona un tutor
            </Button>

            <div className={clsx({'d-none': !hasTutor})}>
                <div className='card-body px-0'>
                    <div className='d-flex text-black' style={{ padding: '0px 10px' }} >
                        <Avatar name={selectedTutor?.first_name} lastname={selectedTutor?.last_name} size={'sm'} />
                        <div className='flex-grow-1 ms-3 fn-s-14 justify-content-between' style={{ textAlign: 'left', display: 'grid', borderRight: !update ? 'none' : '1px solid #ccc', }} >
                            <span className='text-capitalize'> Tutor: {selectedTutor?.first_name}{' '} {selectedTutor?.last_name} </span>
                            <span>Email: {selectedTutor?.email}</span>
                        </div>
                        <div className={clsx({'d-none': !update})}>
                            <span className='span--close' style={{ fontSize: '34px', marginLeft: '15px', marginRight: '5px', }} onClick={handleRemoveTutorClick} > <Icon name='faXmark' /> </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
	)
}

export {SelectTutor as default}